import { render, staticRenderFns } from "./FieldArg.vue?vue&type=template&id=54a28a17&scoped=true&lang=pug&"
import script from "./FieldArg.vue?vue&type=script&lang=ts&"
export * from "./FieldArg.vue?vue&type=script&lang=ts&"
import style0 from "./FieldArg.vue?vue&type=style&index=0&id=54a28a17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a28a17",
  null
  
)

export default component.exports